import { QueryParam } from '../src/var/next/router'
import { safeParseJSON } from '../src/util/src/JSON'
import { decode } from 'js-base64'

export function getRawContext(context: QueryParam): string | undefined {
  switch (typeof context) {
    case 'undefined':
      return undefined
    case 'object':
      return context[0]
    case 'string':
      return context
  }
}

export function getContext(rawContext: string) {
  return safeParseJSON(decode(rawContext))
}

// const packedReflinks = fromReflinksToPackedReflinks(AlexanderLeginReflinks)
// const context = packedReflinks
// const contextJSONString = JSON.stringify(context)
// const contextJSONStringBase64 = encode(contextJSONString)
